import {
	Component,
	EventEmitter,
	Input,
	Output,
	ViewChild
} from '@angular/core';
import { KngContentComponent } from '../content';
import { KngFooterComponent } from '../footer';
import { KngHeaderNavComponent, KngHeaderNavOptionSelectOn } from '../nav';
import { KngCustomerState, KngShell, KngShellState } from './definitions/kng-shell.interface';
import { KngBannerComponent } from '../banner';
import { KngShellService } from './kng-shell.service';
import { Location } from '../../components/nav/header-nav/definitions/kng-header-nav.interface';
import { KngShellFactory } from './kng-shell.factory';
@Component({
	selector: 'kng-shell',
	templateUrl: './template/kng-shell.component.html',
	styleUrls: ['./template/kng-shell.component.scss']
})
export class KngShellComponent implements KngShell
{
  @Input() set state(value: KngShellState)
	{
		this.service.updateState(value);
	}
  @Input() customerState: KngCustomerState = KngShellFactory.buildCustomerState();
  @Output() labelRedirection: EventEmitter<KngHeaderNavOptionSelectOn> =
  	new EventEmitter<KngHeaderNavOptionSelectOn>();
  @Output() bannerClickEvent: EventEmitter<MouseEvent | TouchEvent> =
  	new EventEmitter<MouseEvent | TouchEvent>();
  @Output() languageSelectionChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output() customerSessionEvent: EventEmitter<string> = new EventEmitter<string>();
  
  @Output() locationSelected: EventEmitter<Location> = new EventEmitter<Location>();
  @Output() selectedLang: EventEmitter<string> = new EventEmitter<string>();
  get state(): KngShellState
  {
  	return this.service.state;
  }
  @ViewChild('header', { static: true })
  	headerComponent!: KngHeaderNavComponent;
  @ViewChild('banner', { static: true }) bannerComponent!: KngBannerComponent;
  @ViewChild('content', { static: true })
  	contentComponent!: KngContentComponent;
  @ViewChild('footer', { static: true }) footerComponent!: KngFooterComponent;

  constructor(private service: KngShellService){}
  
  public emitPath(event: KngHeaderNavOptionSelectOn): void
  {
  	this.labelRedirection.emit({
  		event: event.event,
  		selection: event.selection
  	});
  }
  public emitLocation(location: Location): void
  {
  	this.locationSelected.emit(location);
  }
  public notifyAboutLanguageSelection(selection: string)
  {
  	this.languageSelectionChanged.emit(selection);
  }
  bannerClickHandler(event: MouseEvent | TouchEvent)
  {
  	this.bannerClickEvent.emit(event);
  }
  endCustomerSession()
  {
  	this.customerSessionEvent.emit('end');     
  }
  emitSelectedLang(selectedLang: string)
  {
  	this.selectedLang.emit(selectedLang);
  }
}
